import axios from 'axios';
import GlobalURL from './global';

// if (sessionStorage.getItem("erplyLogin") === "1") {
//   var token = sessionStorage.getItem("token");
//   var tokenData = JSON.parse(token);
// } 

// else {
//   var token = localStorage.getItem("token");
//   var tokenData = JSON.parse(token);
// }

var token = sessionStorage.getItem("token");
var tokenData = JSON.parse(token);

let httpclient = axios.create({

  //baseURL: 'http://192.168.1.88/api/',
  //baseURL: 'http://192.168.1.88:8000/api/',
  baseURL: GlobalURL[0].url, 
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
    // 'Content-Type': "application/json",
    Authorization: "Bearer " + tokenData,
  },
});

export default httpclient;